// Define the ErrorWithMetadata class
export class ErrorWithMetadata extends Error {
    public metadata: Record<string, any>;

    constructor(message: string, metadata: Record<string, any>) {
        super(message);
        this.metadata = metadata;
        this.name = 'ErrorWithMetadata';
    }
}
